import React, {ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {flexCenter} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {PaletteColorsEnum} from '../../../../../../libs/shared/ui/src/styles/paletteModel';
import {AnalyticsTableMetricsEnum} from '../../../../../models/api/analyticsMetricsModel';
import {AnalyticsOptionsBucketBoundaries} from '../../../../../models/api/analyticsSavedViewModel';
import {HistoMetricSelection} from '../histoMetricSelectionDropdown';

/*
 * Types.
 */

export interface BucketsPickerProps {
  metric: HistoMetricSelection;
  bucketBoundaries?: AnalyticsOptionsBucketBoundaries;
  color: PaletteColorsEnum;
  onRequestClose: Handler;
  onApply: (
    metricId: AnalyticsTableMetricsEnum,
    newBucketBoundaries: AnalyticsOptionsBucketBoundaries,
  ) => void;
}

/*
 * Style.
 */

export const StyledPickerRowColor = styled.div<{$color: string}>`
  border-radius: 50%;
  background-color: ${(p) => p.$color};
  width: 8px;
  height: 8px;
  margin-right: 8px;
  margin-left: 24px;
`;

export const StyledPickerInputRowDiv = styled.div`
  ${flexCenter}
`;

const StyledPickerButtonsWrapperDiv = styled.div`
  ${flexCenter}
  justify-content: end;
  padding: 8px 20px;
  > * {
    margin-left: 8px;
  }
`;

const StyledPickerSubtitleDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  padding: 20px;
  font-size: ${fontSizes.verySmall};
`;

const StyledPickerErrorDiv = styled.div`
  padding: 10px 20px;
  color: ${(p) => p.theme.palette.red.shade40};
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.small};
  text-align: center;
`;

/*
 * Renderers.
 */

export const renderPickerButtons = (onCancelClick: Handler, onApplyClick: Handler) => (
  <StyledPickerButtonsWrapperDiv>
    <Button variant={ButtonVariantsEnum.SECONDARY} onClick={onCancelClick}>
      <Trans id="response-buckets-picker-cancel">Cancel</Trans>
    </Button>
    <Button variant={ButtonVariantsEnum.PRIMARY} onClick={onApplyClick}>
      <Trans id="response-buckets-picker-apply">Apply</Trans>
    </Button>
  </StyledPickerButtonsWrapperDiv>
);

export const maybeRenderPickerMetricSubtitle = (metricSubtitle?: ReactNode) => {
  if (!metricSubtitle) {
    return null;
  }

  return <StyledPickerSubtitleDiv>{metricSubtitle}</StyledPickerSubtitleDiv>;
};

export const maybeRenderPickerErrorMessage = (shouldShowError: boolean, errorMessage: ReactNode) => {
  if (!shouldShowError) {
    return null;
  }

  return <StyledPickerErrorDiv>{errorMessage}</StyledPickerErrorDiv>;
};
